<template>
  <section class="la-root">

    <!-- ══════════════════════════════════════════
         MÓDULO BOARD (selectedModule == '3')
    ══════════════════════════════════════════ -->
    <div class="la-page" v-if="this.$store.state.selectedModule == '3'">

      <!-- Hero Board -->
      <div class="la-hero la-hero--center">
        <div class="la-glow la-glow--tl"></div>
        <div class="la-glow la-glow--br"></div>
        <div class="la-hero__inner">
          <p class="la-hero__title">
            Bem-vindo ao <span class="la-text--green">LineApps</span>
            <span class="la-text--red"> BOARD</span>!
          </p>
        </div>
      </div>

      <!-- Cards de módulos -->
      <div class="la-section">
        <div class="la-cards-grid la-cards-grid--4">

          <div class="la-card">
            <span class="la-card__icon">📅</span>
            <h3 class="la-card__title">Períodos</h3>
            <p class="la-card__desc">Gerencie e analise dados por períodos contábeis.</p>
            <router-link to="PeriodoPerfil" class="la-btn la-btn--red">Acessar</router-link>
          </div>

          <div class="la-card">
            <span class="la-card__icon">📊</span>
            <h3 class="la-card__title">Balanço</h3>
            <p class="la-card__desc">Visualize os ativos, passivos e patrimônio líquido.</p>
            <router-link to="bpPeriodo" class="la-btn la-btn--green">Acessar</router-link>
          </div>

          <div class="la-card">
            <span class="la-card__icon">📈</span>
            <h3 class="la-card__title">DRE</h3>
            <p class="la-card__desc">Acompanhe a demonstração do resultado do exercício.</p>
            <router-link to="drePeriodo" class="la-btn la-btn--gold">Acessar</router-link>
          </div>

          <div class="la-card">
            <span class="la-card__icon">🎯</span>
            <h3 class="la-card__title">Dashboard</h3>
            <p class="la-card__desc">Obtenha uma visão geral com indicadores chave.</p>
            <router-link to="IndicadorPeriodo" class="la-btn la-btn--blue">Acessar</router-link>
          </div>

        </div>
      </div>

      <footer class="la-footer">
        <span>LineApps <span class="la-text--green">v2026.07-001</span></span>
        <br>
        <span class="has-text-white"><router-link to="/termosDeUso" class="has-text-grey-light">Termos de Uso</router-link></span><span class="has-text-white"> | </span><span class="has-text-white"><router-link to="/politicaPrivacidade" class="has-text-grey-light">Política de Privacidade</router-link></span>
      </footer>
    </div>

    <!-- ══════════════════════════════════════════
         MÓDULO LANDING (selectedModule == '0')
    ══════════════════════════════════════════ -->
    <div class="la-page" v-if="this.$store.state.selectedModule == '0'">

      <!-- ── HERO ── -->
      <div class="la-hero la-hero--split">
        <div class="la-glow la-glow--tl"></div>
        <div class="la-glow la-glow--br la-glow--gold"></div>
        <div class="la-hero__inner la-hero__inner--split">
          <div class="la-hero__copy">
            <h1 class="la-display">
              Seu cliente já tem<br>os números.<br>Agora entregue<br>
              <em class="la-display__accent">a análise</em>.
            </h1>
            <p class="la-hero__sub">
              Diversas empresas não recebem — ou recebem atrasadas — informações que
              ajudam a decidir o dia a dia do negócio. O LineApps fecha essa lacuna —
              transformando os dados da contabilidade em relatórios financeiros executivos,
              indicadores e dashboards prontos para decisão.
            </p>
            <div class="la-hero__actions">
              <a href="#contato" class="la-btn la-btn--primary">Solicitar demonstração</a>
              <a href="#como-funciona" class="la-btn la-btn--ghost">Ver como funciona</a>
            </div>
          </div>
          <div class="la-hero__glass">
            <p class="la-hero__glass-text">
              A maior parte da relação entre empresa e contabilidade hoje é sobre
              <strong class="la-text--bright">cumprir obrigação</strong> — não sobre apoiar decisão.
              O LineApps usa o que já está pronto, o fechamento contábil mensal, para preencher essa
              lacuna automaticamente, sem exigir nenhum dado novo da empresa.
            </p>
          </div>
        </div>
      </div>

      <!-- ── ANTES / DEPOIS ── -->
      <section id="como-funciona" class="la-section">
        <div class="la-container">
          <div class="la-glow la-glow--center"></div>

          <div class="la-label la-label--center">✦ Tempo é o produto</div>

          <h2 class="la-headline la-headline--center">
            O que muda não é a qualidade do número.<br>
            <em class="la-text--green">É quanto tempo você leva para chegar nele.</em>
          </h2>

          <p class="la-subtext la-subtext--center">
            A contabilidade já entrega o fechamento contábil porque é obrigada a isso — mas o
            mercado espera mais: visão financeira de verdade, que apoie decisão.
            Hoje, transformar uma planilha extensa nessa visão significa retrabalho manual e,
            muitas vezes, depender de um especialista para interpretar. Com o LineApps, é o tempo de um upload.
          </p>

          <!-- Antes / Depois -->
          <div class="la-compare">
            <div class="la-compare__side la-compare__side--before">
              <div class="la-compare__tag la-compare__tag--before">Antes</div>
              <div class="la-compare__icon">📄</div>
              <h4 class="la-compare__title">Balancete bruto</h4>
              <p class="la-compare__metric">Centenas de linhas</p>
              <p class="la-compare__desc">Plano de contas extenso, sem estrutura de leitura gerencial.</p>
            </div>

            <div class="la-compare__arrow">
              <span class="la-compare__arrow-label">LineApps</span>
              <span class="la-compare__arrow-icon">→</span>
              <span class="la-compare__arrow-time" id="la-time-counter">~1 min</span>
            </div>

            <div class="la-compare__side la-compare__side--after">
              <div class="la-compare__tag la-compare__tag--after">Depois</div>
              <div class="la-compare__icon">📊</div>
              <h4 class="la-compare__title">Relatório executivo</h4>
              <p class="la-compare__metric">Pronto pra ler</p>
              <p class="la-compare__desc">BP, DRE, Análise Dinâmica e indicadores — organizados para o gestor decidir.</p>
            </div>
          </div>

          <!-- Cards de valor -->
          <div class="la-cards-grid la-cards-grid--4">
            <div class="la-card la-card--center">
              <span class="la-card__icon">⏱️</span>
              <h4 class="la-card__title">Minutos, não dias</h4>
              <p class="la-card__desc">O que hoje depende de planilha manual e retrabalho passa a ser um upload do fechamento contábil.</p>
            </div>
            <div class="la-card la-card--center">
              <span class="la-card__icon">🔁</span>
              <h4 class="la-card__title">Repetível todo mês</h4>
              <p class="la-card__desc">Configurado uma vez por versão de atividade, o modelo se repete automaticamente nos períodos seguintes.</p>
            </div>
            <div class="la-card la-card--center">
              <span class="la-card__icon">🏢</span>
              <h4 class="la-card__title">Escala para várias empresas</h4>
              <p class="la-card__desc">Uma versão configurada pode ser aplicada a todas as empresas do mesmo ramo de atividade.</p>
            </div>
            <div class="la-card la-card--center">
              <span class="la-card__icon">✅</span>
              <h4 class="la-card__title">Sem custo adicional de dados</h4>
              <p class="la-card__desc">Usa o fechamento contábil que a contabilidade já é obrigada a entregar periodicamente — nada novo para pagar ou integrar.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- ── RELATÓRIO EXECUTIVO ── -->
      <section class="la-section">
        <div class="la-container">
          <div class="la-label la-label--center">Relatório Automático</div>

          <h2 class="la-headline la-headline--center">
            Do fechamento contábil ao relatório executivo.<br>
            <em class="la-text--green">Automaticamente.</em>
          </h2>

          <p class="la-subtext la-subtext--center">
            Cada período fechado no LineApps gera um <strong class="la-text--bright">release completo de demonstrações financeiras</strong> —
            com Balanço Patrimonial, DRE, Análise Dinâmica de Balanços e indicadores
            econômico-financeiros com toda a evolução histórica disponível na base.
          </p>
          <p class="la-subtext la-subtext--center la-subtext--mt">
            Pronto para ser lido por gestores, apresentado a um conselho ou
            entregue como diferencial pela contabilidade ao seu cliente final.
          </p>

          <div class="la-divider"></div>

          <div class="la-cards-grid la-cards-grid--4">
            <div class="la-card la-card--center">
              <span class="la-card__icon">📋</span>
              <h4 class="la-card__title">Demonstrações completas</h4>
              <p class="la-card__desc">BP e DRE com <strong class="la-text--green">análise vertical e horizontal</strong>, comparando períodos de forma clara e padronizada.</p>
            </div>
            <div class="la-card la-card--center">
              <span class="la-card__icon">🔬</span>
              <h4 class="la-card__title">Análise Dinâmica de Balanços</h4>
              <p class="la-card__desc">Diagnóstico automático da <strong class="la-text--green">gestão do capital de giro</strong> da empresa.</p>
            </div>
            <div class="la-card la-card--center">
              <span class="la-card__icon">📈</span>
              <h4 class="la-card__title">Histórico completo</h4>
              <p class="la-card__desc">Cada indicador exibe toda a evolução acumulada — <strong class="la-text--green">quanto mais períodos, mais rica a leitura.</strong></p>
            </div>
            <div class="la-card la-card--center">
              <span class="la-card__icon">🚦</span>
              <h4 class="la-card__title">Leitura qualitativa</h4>
              <p class="la-card__desc">Cada indicador pode ser classificado de <strong class="la-text--green">Péssimo a Excelente</strong>, sem depender de interpretação técnica.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- ── DIFERENCIAL / VERSÕES ── -->
      <section class="la-section">
        <div class="la-container">
          <div class="la-label la-label--center">O maior ativo da plataforma</div>

          <h2 class="la-headline la-headline--center">
            Um framework financeiro<br>
            <em class="la-text--green">configurável por segmento.</em>
          </h2>

          <p class="la-subtext la-subtext--center">
            Cada ramo de atividade pode ter sua própria visão — com indicadores e modelos
            de demonstração específicos. Configure uma vez por segmento e aplique
            automaticamente a todas as empresas daquele ramo, sem repetir o trabalho cliente a cliente.
          </p>

          <div class="la-tags la-tags--center">
            <span class="la-tag">Saúde</span>
            <span class="la-tag">Serviços</span>
            <span class="la-tag">Indústria</span>
            <span class="la-tag">Cooperativas</span>
          </div>
        </div>
      </section>

      <!-- ── DADOS ESTRUTURADOS PARA IA ── -->
      <section class="la-section">
        <div class="la-container">
          <div class="la-label la-label--center">✦ Dado bem estruturado</div>

          <h2 class="la-headline la-headline--center">
            A mesma estrutura que organiza o relatório<br>
            <em class="la-text--green">também fala a língua de qualquer IA.</em>
          </h2>

          <p class="la-subtext la-subtext--center">
            Balancete, BP, DRE e indicadores saem do LineApps já nomeados e organizados de
            forma consistente — período a período, conta a conta. Essa mesma estrutura que
            organiza a leitura para um gestor é o que permite que qualquer assistente de IA
            interprete os números sem ambiguidade, sem reformatação manual.
          </p>

          <!-- Terminal -->
          <div class="la-terminal">
            <div class="la-terminal__bar">
              <span class="la-dot la-dot--red"></span>
              <span class="la-dot la-dot--yellow"></span>
              <span class="la-dot la-dot--green"></span>
              <span class="la-terminal__label">assistente-ia.chat</span>
            </div>
            <div class="la-terminal__body">
              <div class="la-msg">
                <div class="la-avatar la-avatar--file">📎</div>
                <div class="la-bubble la-bubble--system">
                  <span class="la-text--green">✓</span>
                  lineapps_balanco_2025.xlsx carregado —
                  <strong class="la-text--bright">Balancete · BP · DRE · 18 indicadores gerenciais</strong>
                </div>
              </div>
              <div class="la-msg">
                <div class="la-avatar la-avatar--user">👤</div>
                <div class="la-bubble la-bubble--user">
                  <span id="ia-typed-text"></span><span class="la-cursor"></span>
                </div>
              </div>
              <div class="la-msg">
                <div class="la-avatar la-avatar--ai">✦</div>
                <div class="la-bubble la-bubble--ai">
                  Com base nos dados estruturados do LineApps, identifiquei que a
                  <span class="la-text--green la-text--semibold">margem líquida cresceu 4,2 p.p.</span>
                  no trimestre, o índice de liquidez corrente está em
                  <span class="la-text--green la-text--semibold">1,87</span> — acima da média do setor —
                  e o EBITDA indica
                  <span class="la-text--green la-text--semibold">capacidade de expansão</span>
                  sem necessidade de alavancagem adicional.
                </div>
              </div>
            </div>
          </div>

          <div class="la-cards-grid la-cards-grid--3">
            <div class="la-card la-card--center">
              <span class="la-card__icon">🧩</span>
              <h4 class="la-card__title">Estrutura consistente</h4>
              <p class="la-card__desc">Cada linha de BP, DRE e indicador tem nome, posição e fórmula padronizados — sem ambiguidade entre períodos ou empresas.</p>
            </div>
            <div class="la-card la-card--center">
              <span class="la-card__icon">🔗</span>
              <h4 class="la-card__title">Pronto para qualquer IA</h4>
              <p class="la-card__desc">A mesma estrutura que organiza o relatório para leitura humana funciona com ChatGPT, Claude ou qualquer outro assistente, sem conversão.</p>
            </div>
            <div class="la-card la-card--center">
              <span class="la-card__icon">🎯</span>
              <h4 class="la-card__title">Sem retrabalho de formatação</h4>
              <p class="la-card__desc">Dados já vêm prontos para análise — não é preciso limpar planilha ou explicar contexto antes de perguntar.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- ── SOBRE / PARA QUEM ── -->
      <section id="sobre" class="la-section">
        <div class="la-container la-container--narrow">
          <div class="la-label">Para quem é</div>
          <h3 class="la-headline">Pensado para quem entrega análise — e para quem recebe.</h3>
          <div class="la-two-col">
            <p class="la-body"><strong class="la-text--bright">Para a contabilidade e o BPO:</strong> um jeito de
            entregar mais valor com o mesmo balancete que você já recebe — sem aumentar a equipe.</p>
            <p class="la-body"><strong class="la-text--bright">Para o gestor que recebe:</strong> deixa de depender de
            planilha e tradução manual — todo mês, os números que importam para decidir chegam prontos.</p>
          </div>
        </div>
      </section>

      <!-- ── ESCRITÓRIOS CONTÁBEIS ── -->
      <section class="la-section">
        <div class="la-container la-container--narrow la-container--center">
          <div class="la-label la-label--center">Para escritórios e BPO contábil</div>
          <h2 class="la-headline la-headline--center">
            Transforme seu escritório contábil<br>
            <em class="la-text--green">em uma consultoria financeira.</em>
          </h2>
          <p class="la-subtext la-subtext--center">
            Crie uma nova linha de receita entregando análises executivas aos seus clientes —
            sem precisar montar uma equipe de controladoria.
          </p>
          <div class="la-hero__actions la-hero__actions--center">
            <a href="#contato" class="la-btn la-btn--primary">Solicitar demonstração</a>
          </div>
        </div>
      </section>

      <!-- ── CONTEXTOS ── -->
      <section class="la-section">
        <div class="la-container">
          <div class="la-two-col la-two-col--gap">
            <div>
              <h3 class="la-headline la-headline--sm">Contextos onde o LineApps faz sentido</h3>
              <div class="la-tags">
                <span class="la-tag">Contabilidade Gerencial</span>
                <span class="la-tag">BPO Contábil</span>
                <span class="la-tag">Controladoria</span>
                <span class="la-tag">FP&amp;A</span>
              </div>
            </div>
            <div class="la-card la-card--flush">
              <h4 class="la-card__title la-card__title--lg">O que não é?</h4>
              <ul class="la-list">
                <li>Não substitui ERPs ou sistemas contábeis</li>
                <li>Não exige nenhum dado além do fechamento contábil que já é entregue</li>
                <li>Não altera normas contábeis</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!-- ── CTA ── -->
      <section id="contato" class="la-section la-section--cta">
        <div class="la-glow la-glow--center la-glow--gold"></div>
        <div class="la-container la-container--narrow la-container--center">
          <h3 class="la-headline la-headline--center">Veja como transformar um fechamento contábil em uma visão executiva do negócio.</h3>
          <p class="la-subtext la-subtext--center">Demonstração para a sua empresa, parceria com sua contabilidade ou um piloto com o seu próprio fechamento contábil.</p>
          <div class="la-hero__actions la-hero__actions--center">
            <a href="https://wa.me/5581994032445" target="_blank" class="la-btn la-btn--primary">Agendar demonstração</a>
          </div>
          <div class="la-cta-links">
            <a class="la-cta-icon" href="https://wa.me/5581994032445" target="_blank" title="WhatsApp">
              <i class="fab fa-whatsapp"></i>
            </a>
            <a class="la-cta-icon" href="mailto:lineapps@pgpaf.com.br" target="_blank" title="E-mail">
              <i class="fa fa-at"></i>
            </a>
            <a class="la-cta-icon" href="https://www.linkedin.com/company/lineappscombr" target="_blank" title="LinkedIn">
              <i class="fab fa-linkedin"></i>
            </a>
          </div>
        </div>
      </section>

      <footer class="la-footer">
        <span class="has-text-white">LineApps © 2026</span>
        <br>
        <span class="has-text-white"><router-link to="/termosDeUso" class="has-text-grey-light">Termos de Uso</router-link></span><span class="has-text-white"> | </span><span class="has-text-white"><router-link to="/politicaPrivacidade" class="has-text-grey-light">Política de Privacidade</router-link></span>
      </footer>

    </div>
  </section>
</template>

<script>
export default {
  name: "MenuPrincipal",

  methods: {},

  mounted() {
    // Animação do contador de tempo na seção Antes/Depois.
    // Simula um relógio descendo rapidamente de "horas" até estabilizar em "~1 min".
    const timeEl = document.getElementById("la-time-counter");
    if (timeEl) {
      const frames = ["Horas...", "Minutos...", "Segundos...", "~1 min"];
      let i = 0;

      const tickTime = () => {
        timeEl.textContent = frames[i];
        i++;
        if (i < frames.length) {
          setTimeout(tickTime, 450);
        }
      };

      this.$nextTick(() => { setTimeout(tickTime, 300); });
    }

    // Animação de digitação do terminal de IA na seção "Dados Estruturados".
    const prompts = [
      "Qual é a tendência de lucratividade nos últimos 3 períodos?",
      "A empresa consegue honrar suas dívidas de curto prazo?",
      "Onde estão os maiores riscos financeiros do balanço?",
      "Compare o EBITDA com o setor e aponte oportunidades.",
    ];
    let promptIndex = 0;
    let charIndex = 0;

    const getEl = () => document.getElementById("ia-typed-text");

    const type = () => {
      const el = getEl(); if (!el) return;
      const text = prompts[promptIndex];
      if (charIndex < text.length) {
        el.textContent += text[charIndex++];
        setTimeout(type, 40);
      } else {
        setTimeout(erase, 2400);
      }
    };

    const erase = () => {
      const el = getEl(); if (!el) return;
      const text = prompts[promptIndex];
      if (charIndex > 0) {
        el.textContent = text.slice(0, --charIndex);
        setTimeout(erase, 22);
      } else {
        promptIndex = (promptIndex + 1) % prompts.length;
        setTimeout(type, 500);
      }
    };

    if (getEl()) {
      this.$nextTick(() => { type(); });
    }
  },

  created() {},
};
</script>

<style scoped>
/* ════════════════════════════════════════════════
   DESIGN TOKENS
════════════════════════════════════════════════ */
.la-root {
  --bg:            #0a0c10;
  --surface:       #111318;
  --surface-2:     #181c24;
  --border:        rgba(255,255,255,0.07);
  --border-green:  rgba(99,190,140,0.3);
  --text:          #e8eaf0;
  --text-muted:    #7a8099;
  --text-dim:      #4a5068;
  --green:         #63be8c;
  --green-glow:    rgba(99,190,140,0.15);
  --green-soft:    rgba(99,190,140,0.08);
  --gold:          #c9a84c;
  --gold-soft:     rgba(201,168,76,0.08);
  --red:           #e05c5c;
  --blue:          #5c9fe0;
  --font-display:  -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
  --font-body:     -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
  --font-mono:     'SF Mono', ui-monospace, 'Cascadia Code', 'Fira Code', monospace;

  background: var(--bg);
  color: var(--text);
  font-family: var(--font-body);
  min-height: 100vh;
}

/* noise overlay */
.la-root::before {
  content: '';
  position: fixed;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E");
  pointer-events: none;
  z-index: 0;
  opacity: 0.6;
}

.la-page { position: relative; z-index: 1; }

/* ════════════════════════════════════════════════
   GLOW ORBS
════════════════════════════════════════════════ */
.la-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  pointer-events: none;
  z-index: 0;
}
.la-glow--tl  { width: 500px; height: 500px; background: radial-gradient(circle, var(--green-glow) 0%, transparent 70%); top: -100px; left: -150px; }
.la-glow--br  { width: 400px; height: 400px; background: radial-gradient(circle, var(--green-glow) 0%, transparent 70%); bottom: 0; right: -100px; }
.la-glow--center { width: 600px; height: 400px; background: radial-gradient(circle, var(--green-glow) 0%, transparent 70%); top: 50%; left: 50%; transform: translate(-50%,-50%); }
.la-glow--gold { background: radial-gradient(circle, var(--gold-soft) 0%, transparent 70%) !important; }

/* ════════════════════════════════════════════════
   HERO
════════════════════════════════════════════════ */
.la-hero {
  position: relative;
  overflow: hidden;
  padding: 120px 24px 80px;
  background: linear-gradient(180deg, rgba(99,190,140,0.04) 0%, transparent 60%);
  border-bottom: 1px solid var(--border);
}
.la-hero--center { text-align: center; }

.la-hero__inner {
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.la-hero__inner--split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}
@media (max-width: 768px) {
  .la-hero__inner--split { grid-template-columns: 1fr; gap: 40px; }
}

.la-hero__title {
  font-family: var(--font-display);
  font-size: clamp(2.2rem, 5vw, 3.6rem);
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.03em;
  color: var(--text);
}

.la-hero__sub {
  color: var(--text-muted);
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.8;
  margin-top: 20px;
  max-width: 460px;
}

.la-hero__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 36px;
}
.la-hero__actions--center {
  justify-content: center;
}

.la-hero__glass {
  background: rgba(255,255,255,0.03);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 32px;
  backdrop-filter: blur(10px);
}
.la-hero__glass-text {
  color: var(--text-muted);
  font-weight: 300;
  line-height: 1.85;
}

/* ════════════════════════════════════════════════
   DISPLAY TITLE
════════════════════════════════════════════════ */
.la-display {
  font-family: var(--font-display);
  font-size: clamp(2.4rem, 5vw, 4rem);
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.035em;
  color: var(--text);
}
.la-display__accent {
  font-style: normal;
  background: linear-gradient(90deg, var(--green) 0%, #a8e6c4 60%, var(--gold) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
}
.la-display__accent::after {
  content: '';
  position: absolute;
  bottom: 4px; left: 0; right: 0;
  height: 2px;
  background: linear-gradient(90deg, var(--green), var(--gold), transparent);
  border-radius: 2px;
}

/* ════════════════════════════════════════════════
   LAYOUT HELPERS
════════════════════════════════════════════════ */
.la-section {
  position: relative;
  padding: 96px 24px;
  overflow: hidden;
}
.la-section--cta {
  background: linear-gradient(180deg, transparent, rgba(99,190,140,0.04));
  border-top: 1px solid var(--border);
}

.la-container {
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.la-container--narrow { max-width: 820px; }
.la-container--center { text-align: center; }

.la-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  margin-top: 32px;
}
.la-two-col--gap { gap: 48px; align-items: start; }
@media (max-width: 640px) {
  .la-two-col { grid-template-columns: 1fr; }
}

/* ════════════════════════════════════════════════
   LABEL (badge pill)
════════════════════════════════════════════════ */
.la-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--green);
  background: var(--green-soft);
  border: 1px solid var(--border-green);
  padding: 6px 14px;
  border-radius: 4px;
  margin-bottom: 28px;
}
.la-label--center { display: flex; justify-content: center; margin: 0 auto 28px; width: fit-content; }
.la-label::before {
  content: '';
  width: 6px; height: 6px;
  border-radius: 50%;
  background: var(--green);
  box-shadow: 0 0 8px var(--green);
  animation: la-pulse 2s infinite;
}

/* ════════════════════════════════════════════════
   HEADLINES & TEXT
════════════════════════════════════════════════ */
.la-headline {
  font-family: var(--font-display);
  font-size: clamp(1.8rem, 4vw, 3rem);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--text);
  margin-bottom: 24px;
}
.la-headline em {
  font-style: normal;
  background: linear-gradient(90deg, var(--green) 0%, #a8e6c4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.la-headline--center { text-align: center; }
.la-headline--sm { font-size: clamp(1.4rem, 3vw, 2rem); }

.la-subtext {
  color: var(--text-muted);
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.85;
}
.la-subtext--center { text-align: center; max-width: 700px; margin: 0 auto; }
.la-subtext--mt { margin-top: 16px; }

.la-body { color: var(--text-muted); font-weight: 300; line-height: 1.85; }

.la-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border), transparent);
  margin: 56px 0;
}

/* ════════════════════════════════════════════════
   CARDS
════════════════════════════════════════════════ */
.la-cards-grid {
  display: grid;
  gap: 16px;
  margin-top: 48px;
}
.la-cards-grid--4 { grid-template-columns: repeat(4, 1fr); }
.la-cards-grid--3 { grid-template-columns: repeat(3, 1fr); }
@media (max-width: 900px) {
  .la-cards-grid--4 { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 640px) {
  .la-cards-grid--4,
  .la-cards-grid--3 { grid-template-columns: 1fr; }
}

.la-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 28px 24px;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease, opacity 0.25s ease;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.la-card--center { align-items: center; text-align: center; }
.la-card--flush { padding: 28px 24px; }

.la-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--green-soft) 0%, transparent 60%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}
.la-card:hover {
  border-color: var(--border-green);
  transform: translateY(-3px);
  box-shadow: 0 20px 60px rgba(0,0,0,0.4), 0 0 0 1px rgba(99,190,140,0.1);
}
.la-card:hover::before { opacity: 1; }

/* dim siblings on hover */
.la-cards-grid:hover .la-card:not(:hover) { opacity: 0.6; }

.la-card__icon {
  font-size: 1.8rem;
  line-height: 1;
  position: relative;
  z-index: 1;
}
.la-card__title {
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text);
  position: relative;
  z-index: 1;
}
.la-card__title--lg { font-size: 1.1rem; }
.la-card__desc {
  font-size: 0.82rem;
  color: var(--text-muted);
  font-weight: 300;
  line-height: 1.7;
  position: relative;
  z-index: 1;
}

/* ════════════════════════════════════════════════
   BUTTONS
════════════════════════════════════════════════ */
.la-btn {
  display: inline-block;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid transparent;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  z-index: 1;
  margin-top: 8px;
  align-self: flex-start;
}
.la-card--center .la-btn { align-self: center; }

.la-btn--primary {
  background: var(--text);
  color: var(--bg);
  border-color: var(--text);
}
.la-btn--primary:hover { background: var(--green); border-color: var(--green); }

.la-btn--ghost {
  background: transparent;
  color: var(--text-muted);
  border-color: var(--border);
}
.la-btn--ghost:hover { border-color: var(--text-muted); color: var(--text); }

.la-btn--green {
  background: var(--green-soft);
  color: var(--green);
  border-color: var(--border-green);
}
.la-btn--green:hover { background: rgba(99,190,140,0.18); }

.la-btn--red {
  background: rgba(224,92,92,0.08);
  color: var(--red);
  border-color: rgba(224,92,92,0.3);
}
.la-btn--red:hover { background: rgba(224,92,92,0.16); }

.la-btn--gold {
  background: var(--gold-soft);
  color: var(--gold);
  border-color: rgba(201,168,76,0.3);
}
.la-btn--gold:hover { background: rgba(201,168,76,0.16); }

.la-btn--blue {
  background: rgba(92,159,224,0.08);
  color: var(--blue);
  border-color: rgba(92,159,224,0.3);
}
.la-btn--blue:hover { background: rgba(92,159,224,0.16); }

/* ════════════════════════════════════════════════
   TAGS
════════════════════════════════════════════════ */
.la-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
}
.la-tags--center {
  justify-content: center;
  margin-top: 32px;
}
.la-tag {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--green);
  background: var(--green-soft);
  border: 1px solid var(--border-green);
  padding: 5px 12px;
  border-radius: 4px;
}

/* ════════════════════════════════════════════════
   LIST
════════════════════════════════════════════════ */
.la-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}
.la-list li {
  color: var(--text-muted);
  font-weight: 300;
  font-size: 0.9rem;
  padding-left: 18px;
  position: relative;
}
.la-list li::before {
  content: '—';
  position: absolute;
  left: 0;
  color: var(--text-dim);
}

/* ════════════════════════════════════════════════
   TERMINAL
════════════════════════════════════════════════ */
.la-terminal {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
  max-width: 760px;
  margin: 40px auto 0;
  backdrop-filter: blur(10px);
}
.la-terminal__bar {
  background: rgba(0,0,0,0.3);
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid var(--border);
}
.la-dot {
  width: 10px; height: 10px;
  border-radius: 50%;
  display: inline-block;
}
.la-dot--red    { background: #ff5f57; }
.la-dot--yellow { background: #ffbd2e; }
.la-dot--green  { background: #28ca41; }
.la-terminal__label {
  color: var(--text-dim);
  font-size: 11px;
  font-family: var(--font-mono);
  margin-left: 8px;
}
.la-terminal__body {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.la-msg { display: flex; align-items: flex-start; gap: 10px; }

.la-avatar {
  width: 32px; height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.la-avatar--file { background: linear-gradient(135deg, var(--green), #0077ff); }
.la-avatar--user { background: var(--surface-2); border-radius: 50%; }
.la-avatar--ai   { background: linear-gradient(135deg, #0077ff, #6c3fff); color: #fff; font-size: 12px; }

.la-bubble {
  border-radius: 4px 10px 10px 10px;
  padding: 10px 14px;
  font-size: 13px;
  line-height: 1.65;
  max-width: 620px;
}
.la-bubble--system {
  background: rgba(0,0,0,0.25);
  color: var(--text-dim);
  font-family: var(--font-mono);
}
.la-bubble--user {
  background: var(--surface-2);
  color: #c2d4ef;
  min-height: 40px;
  display: flex;
  align-items: center;
}
.la-bubble--ai {
  background: rgba(0,0,0,0.2);
  border: 1px solid var(--border);
  color: var(--text-muted);
}

.la-cursor {
  display: inline-block;
  width: 2px; height: 14px;
  background: var(--green);
  margin-left: 2px;
  vertical-align: middle;
  animation: la-blink 1s step-end infinite;
}

/* ════════════════════════════════════════════════
   ANTES / DEPOIS (comparação)
════════════════════════════════════════════════ */
.la-compare {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 24px;
  align-items: center;
  max-width: 880px;
  margin: 48px auto 0;
}
@media (max-width: 768px) {
  .la-compare {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.la-compare__side {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 32px 24px;
  text-align: center;
  position: relative;
  backdrop-filter: blur(10px);
}
.la-compare__side--before { border-color: var(--border); }
.la-compare__side--after  { border-color: var(--border-green); }

.la-compare__tag {
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%);
  font-family: var(--font-mono);
  font-size: 0.68rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding: 4px 12px;
  border-radius: 4px;
  white-space: nowrap;
}
.la-compare__tag--before {
  background: var(--surface-2);
  color: var(--text-dim);
  border: 1px solid var(--border);
}
.la-compare__tag--after {
  background: var(--green-soft);
  color: var(--green);
  border: 1px solid var(--border-green);
}

.la-compare__icon {
  font-size: 2rem;
  margin-top: 8px;
}
.la-compare__title {
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--text);
  margin-top: 12px;
}
.la-compare__metric {
  font-family: var(--font-mono);
  font-size: 1.6rem;
  font-weight: 700;
  margin-top: 6px;
}
.la-compare__side--before .la-compare__metric { color: var(--text-muted); }
.la-compare__side--after  .la-compare__metric { color: var(--green); }

.la-compare__desc {
  font-size: 0.82rem;
  color: var(--text-muted);
  font-weight: 300;
  line-height: 1.6;
  margin-top: 10px;
}

.la-compare__arrow {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
}
.la-compare__arrow-label {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-dim);
}
.la-compare__arrow-icon {
  font-size: 1.6rem;
  color: var(--green);
  line-height: 1;
}
.la-compare__arrow-time {
  font-family: var(--font-mono);
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--gold);
  min-width: 90px;
  text-align: center;
}
@media (max-width: 768px) {
  .la-compare__arrow {
    flex-direction: row;
    justify-content: center;
  }
  .la-compare__arrow-icon { transform: rotate(90deg); }
}

/* ════════════════════════════════════════════════
   CTA LINKS
════════════════════════════════════════════════ */
.la-cta-links {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 36px;
}
.la-cta-icon {
  width: 48px; height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: var(--text-muted);
  background: var(--surface);
  border: 1px solid var(--border);
  text-decoration: none;
  transition: all 0.2s ease;
}
.la-cta-icon:hover {
  color: var(--green);
  border-color: var(--border-green);
  background: var(--green-soft);
  transform: translateY(-2px);
}

/* ════════════════════════════════════════════════
   FOOTER
════════════════════════════════════════════════ */
.la-footer {
  border-top: 1px solid var(--border);
  padding: 24px;
  text-align: right;
  font-size: 0.8rem;
  color: var(--text-dim);
  position: relative;
  z-index: 1;
}

/* ════════════════════════════════════════════════
   TEXT UTILITIES
════════════════════════════════════════════════ */
.la-text--green {
  background: linear-gradient(90deg, var(--green) 0%, #a8e6c4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.la-text--gold    { color: var(--gold); }
.la-text--red     { color: var(--red); }
.la-text--bright  { color: var(--text); }
.la-text--semibold { font-weight: 600; }

/* ════════════════════════════════════════════════
   ANIMATIONS
════════════════════════════════════════════════ */
@keyframes la-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.5; transform: scale(0.8); }
}
@keyframes la-blink {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0; }
}
</style>